var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChangelog = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "m22 13-5.707 2.853c-1.574.787-2.361 1.181-3.187 1.336a6 6 0 0 1-2.212 0c-.826-.155-1.613-.549-3.187-1.336L2 13m20 5-5.707 2.853c-1.574.787-2.361 1.181-3.187 1.336a6 6 0 0 1-2.212 0c-.826-.155-1.613-.549-3.187-1.336L2 18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.138 2.431c1.05-.525 1.574-.787 2.124-.89a4 4 0 0 1 1.476 0c.55.103 1.075.365 2.124.89l3.414 1.707c1.842.921 2.763 1.382 3.059 2.005a2 2 0 0 1 0 1.714c-.296.623-1.217 1.084-3.06 2.005l-3.413 1.707c-1.05.525-1.574.787-2.124.89a4.003 4.003 0 0 1-1.476 0c-.55-.103-1.075-.365-2.124-.89L5.724 9.862C3.882 8.941 2.961 8.48 2.665 7.857a2 2 0 0 1 0-1.714c.296-.623 1.217-1.084 3.06-2.005L9.137 2.43Z"
})));
export default SvgChangelog;